// extracted by mini-css-extract-plugin
export var arrow = "Amenities-module--arrow--b4012";
export var backButton = "Amenities-module--backButton--3644f";
export var backgroundImage = "Amenities-module--backgroundImage--e671c";
export var card = "Amenities-module--card--2e73a";
export var cardsWrapper = "Amenities-module--cardsWrapper--4fc20";
export var carousel = "Amenities-module--carousel--0303e";
export var carouselContainer = "Amenities-module--carouselContainer--7a297";
export var container = "Amenities-module--container--1fc60";
export var content = "Amenities-module--content--88391";
export var decor = "Amenities-module--decor--8bdb8";
export var decorLine = "Amenities-module--decorLine--77889";
export var divider = "Amenities-module--divider--39156";
export var foregroundImage = "Amenities-module--foregroundImage--0b2b1";
export var hamburger = "Amenities-module--hamburger--6a973";
export var image = "Amenities-module--image--41ff2";
export var info = "Amenities-module--info--a99ca";
export var microLogo = "Amenities-module--microLogo--23205";
export var mobileTabs = "Amenities-module--mobileTabs--7b259";
export var nextButton = "Amenities-module--nextButton--91682";
export var reactCalendarMonthViewDays = "Amenities-module--react-calendar__month-view__days--16c54";
export var reactCalendarTile = "Amenities-module--react-calendar__tile--16eeb";
export var reactCalendarTileActive = "Amenities-module--react-calendar__tile--active--0c80f";
export var relativeWrapper = "Amenities-module--relativeWrapper--2af02";
export var selected = "Amenities-module--selected--77146";
export var tab = "Amenities-module--tab--3d4d6";
export var tabs = "Amenities-module--tabs--f38c9";
export var textContainer = "Amenities-module--textContainer--bf578";
export var units = "Amenities-module--units--acf92";